/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertyChangeDto } from './PropertyChangeDto';
import {
    PropertyChangeDtoFromJSON,
    PropertyChangeDtoFromJSONTyped,
    PropertyChangeDtoToJSON,
    PropertyChangeDtoToJSONTyped,
} from './PropertyChangeDto';

/**
 * 
 * @export
 * @interface AuditEntryDto
 */
export interface AuditEntryDto {
    /**
     * Time of the change
     * @type {Date}
     * @memberof AuditEntryDto
     */
    changeTime?: Date;
    /**
     * Name of the user who made the change
     * @type {string}
     * @memberof AuditEntryDto
     */
    userName?: string;
    /**
     * IP address of the client
     * @type {string}
     * @memberof AuditEntryDto
     */
    clientIpAddress?: string;
    /**
     * Type of the entity
     * @type {string}
     * @memberof AuditEntryDto
     */
    entityType?: string;
    /**
     * ID of the entity
     * @type {string}
     * @memberof AuditEntryDto
     */
    entityId?: string;
    /**
     * Type of the change
     * @type {string}
     * @memberof AuditEntryDto
     */
    changeType?: string;
    /**
     * HTTP method used
     * @type {string}
     * @memberof AuditEntryDto
     */
    httpMethod?: string;
    /**
     * URL of the request
     * @type {string}
     * @memberof AuditEntryDto
     */
    url?: string;
    /**
     * Browser information
     * @type {string}
     * @memberof AuditEntryDto
     */
    browserInfo?: string;
    /**
     * Contextual label for the audit entry
     * @type {string}
     * @memberof AuditEntryDto
     */
    contextLabel?: string;
    /**
     * List of property changes
     * @type {Array<PropertyChangeDto>}
     * @memberof AuditEntryDto
     */
    propertyChanges?: Array<PropertyChangeDto>;
}

/**
 * Check if a given object implements the AuditEntryDto interface.
 */
export function instanceOfAuditEntryDto(value: object): value is AuditEntryDto {
    return true;
}

export function AuditEntryDtoFromJSON(json: any): AuditEntryDto {
    return AuditEntryDtoFromJSONTyped(json, false);
}

export function AuditEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'changeTime': json['changeTime'] == null ? undefined : (new Date(json['changeTime'])),
        'userName': json['userName'] == null ? undefined : json['userName'],
        'clientIpAddress': json['clientIpAddress'] == null ? undefined : json['clientIpAddress'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'changeType': json['changeType'] == null ? undefined : json['changeType'],
        'httpMethod': json['httpMethod'] == null ? undefined : json['httpMethod'],
        'url': json['url'] == null ? undefined : json['url'],
        'browserInfo': json['browserInfo'] == null ? undefined : json['browserInfo'],
        'contextLabel': json['contextLabel'] == null ? undefined : json['contextLabel'],
        'propertyChanges': json['propertyChanges'] == null ? undefined : ((json['propertyChanges'] as Array<any>).map(PropertyChangeDtoFromJSON)),
    };
}

export function AuditEntryDtoToJSON(json: any): AuditEntryDto {
    return AuditEntryDtoToJSONTyped(json, false);
}

export function AuditEntryDtoToJSONTyped(value?: AuditEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changeTime': value['changeTime'] == null ? undefined : ((value['changeTime']).toISOString()),
        'userName': value['userName'],
        'clientIpAddress': value['clientIpAddress'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'changeType': value['changeType'],
        'httpMethod': value['httpMethod'],
        'url': value['url'],
        'browserInfo': value['browserInfo'],
        'contextLabel': value['contextLabel'],
        'propertyChanges': value['propertyChanges'] == null ? undefined : ((value['propertyChanges'] as Array<any>).map(PropertyChangeDtoToJSON)),
    };
}

